import { createStore } from "vuex";

export default createStore({
  state: {
    rc_branch:null,
    hash:null,
    full_name:null,
    employee_key:null,
    emp_info:null,
    branch:null,
    list_employee:null,
    access:null,
    divisionList:[],
    departmentList:[],
    sectionList:[],
    position_key: null,
    religion:[
      {
         key : 1,
         name : 'ROMAN CATHOLIC'
      },
      {
        key : 1,
        name : 'ISLAM'
      },
      {
        key : 1,
        name : 'IGLESIA NI CRISTO'
      },
      {
        key : 1,
        name : 'CHRISTIAN'
      },
      {
        key : 1,
        name : 'PHILIPPINE INDEPENDENT CHURCH'
      },
      {
        key : 1,
        name : 'SEVETH-DAY ADVENTIST'
      },
      {
        key : 1,
        name : 'BUDDHISM'
      },
      {
        key : 1,
        name : "JEHOVAH'S WITNESSES"
      },
      {
        key : 1,
        name : "LATTER-DAY SAINTS"
      },
      {
        key : 1,
        name : "PROTESTANT"
      },
      {
        key : 1,
        name : "PENTECOSTAL"
      },
    ],
  }
});

